import React from 'react';
import {
    Container,
    Row,
    Col
} from 'react-bootstrap';
import '@fortawesome/fontawesome-free/css/all.min.css';
import useWindowDimensions from "./useWindowDimensions";
import iskur from '../assets/iskurlogo.gif';

const Footer = (props) => {

    const { height, width } = useWindowDimensions();

    return (
        <div>
            <footer style={{backgroundColor:'#120928'}} className="font-small pt-4 mt-4">
                <Container fluid className="text-center text-md-left">
                    <div className="icon-cards">
                        <Row className="align-content-center">
                            <Col md="6">
                                <h5 className="title" style={{color: '#fff'}}></h5>
                                <p style={{color: '#fff'}}>
                                   Balıkesir Bakıcı Ajansı; Ankafiz Fizyoterapi Hizmetleri İş Bulma
                                    Acenteliği ve Danışmanlığı unvanıyla Türkiye İş Kurumu’nun 28/04/2025
                                    tarih ve 1.841 numaralı aracılık izin belgesi ile faaliyet göstermektedir.
                                    4904 sayılı Kanun uyarınca iş arayandan ücret alınması yasaktır.

                                </p>
                                <p>Şikayetleriniz için Balıkesir Çalışma ve İş Kurumu:  266 241 17 91 </p>
                                <p>Bizimle iletişim için:   545 183 10 10 - 545 183 10 11 </p>
                                <img src={iskur} alt=""/>
                            </Col>
                            {}
                            {width > 700 ? <>
                            <Col md="3">

                                <h5 className="title" style={{color: '#fff' ,marginLeft:'30%'}}>Sosyal Medya</h5>
                                <ul>
                                    <li className="list-unstyled">
                                        <a href="https://www.instagram.com/balikesirbakiciajansi?igsh=MTN1NjJ2eDl4ZnFtZQ==" style={{width:40}} className="ins-ic mr-3">
                                            <i className="fab fa-instagram" />
                                        </a>
                                    </li>
                                    <a href="https://www.facebook.com/share/16P6CmnPhG/" className="fb-ic mr-3">
                                        <i className="fab fa-facebook-f" />
                                    </a>
                                    <li className="list-unstyled">
                                        <a href="https://www.linkedin.com/company/balikesirkbdanismanlik" className="li-ic mr-3">
                                            <i className="fab fa-linkedin-in" />
                                        </a>
                                    </li>
                                </ul>
                            </Col>
                            <Col md="3">
                                <h5 className="title" style={{color: '#fff' ,marginLeft:'30%'}}>Sayfalar</h5>
                                <ul>
                                    <li className="list-unstyled">
                                        <a href="/about" style={{width:40}} className="ins-ic mr-3 title">
                                            Hakkımızda
                                        </a>
                                    </li>
                                    <a href="/contact" className="fb-ic mr-3">
                                        İletişim
                                    </a>
                                    <li className="list-unstyled">
                                        <a href="/services" className="li-ic mr-3">
                                            İşlerimiz
                                        </a>
                                    </li>
                                </ul>
                            </Col>
                                    </> :  <div></div>}
                        </Row>
                    </div>
                </Container>
                <div className="footer-copyright text-center py-3">
                    <Container fluid style={{color:'#fff'}}>
                        &copy; {new Date().getFullYear()} Copyright: <a href="https://www.balikesirbakiciajansi.com"> Balıkesir Bakıcı Ajansı </a>
                    </Container>
                </div>
            </footer>
            {width<700 ? <div style={{height:70}}></div>: <div></div> }
        </div>
    );
}

const styles={
    image:{
        width: '50%',
        height: '50%',
        borderRadius : '1%',
    },
    text:{
        textAlign: 'center',
        color: '#000'
    },
    container:{
        marginTop: 50,
    }
}

export default Footer;
